/** Football season: 1 Aug → 31 Jul. `endYear` is the year in July (label "startYear–endYear"). */

export const SEASON_START_MONTH = 8; // August (1-based)

/** Season a newly uploaded goal belongs to (rolls on 1 August). */
export function getSeasonEndYear(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return month >= SEASON_START_MONTH ? year + 1 : year;
}

/**
 * Season shown by default for Goal of the Season voting.
 * Voting continues after 31 Jul, so in Aug–Dec we still default to the
 * season that just ended (calendar year), not the new football season.
 */
export function getVotingSeasonEndYear(date = new Date()) {
  return date.getFullYear();
}

export function getSeasonStartYear(endYear) {
  return Number(endYear) - 1;
}

export function getSeasonLabel(endYear) {
  const end = Number(endYear);
  return `${end - 1}-${end}`;
}

export function getSeasonOptions(count = 5, date = new Date()) {
  const newest = Math.max(getSeasonEndYear(date), getVotingSeasonEndYear(date));
  return Array.from({ length: count }, (_, i) => {
    const endYear = newest - i;
    return {
      endYear: String(endYear),
      startYear: String(endYear - 1),
      label: getSeasonLabel(endYear),
    };
  });
}
